// Boot → NoWebGL | Title → Broadcast. Listeners run on every change.

export type AppStateName = 'boot' | 'noWebGL' | 'title' | 'broadcast';

const allowed: Record<AppStateName, AppStateName[]> = {
  boot: ['noWebGL', 'title', 'broadcast'],
  noWebGL: [],
  title: ['broadcast'],
  broadcast: ['title'],
};

export class AppState {
  private current: AppStateName = 'boot';
  private listeners = new Set<(s: AppStateName, prev: AppStateName) => void>();

  get value(): AppStateName {
    return this.current;
  }

  go(next: AppStateName): void {
    if (next === this.current) return;
    if (!allowed[this.current].includes(next)) {
      throw new Error(`appState: ${this.current} → ${next} is not allowed`);
    }
    const prev = this.current;
    this.current = next;
    document.documentElement.dataset.appState = next;
    for (const l of this.listeners) l(next, prev);
  }

  on(listener: (s: AppStateName, prev: AppStateName) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}

export const appState = new AppState();
